import { takeLatest, put, all, call } from 'redux-saga/effects';
import { appsAPI, availableAppsAPI } from 'resources/api';
import { processError } from 'state/utils';
import Types from './types';

function* fetchStartAsync() {
    try {
        const res = yield appsAPI.getAll();
        yield put({ type: Types.FETCH_SUCCESS, payload: res });
    } catch (error) {
        const message = processError(error);
        console.error(message);
        yield put({ type: Types.FETCH_ERROR, payload: message });
    }
}

function* fetchStart() {
    yield takeLatest(Types.FETCH_START, fetchStartAsync);
}

function* fetchAvailableAsync() {
    try {
        const res = yield availableAppsAPI.getAll();
        yield put({ type: Types.FETCH_AVAILABLE_SUCCESS, payload: res });
    } catch (error) {
        const message = processError(error);
        console.error(message);
        yield put({ type: Types.FETCH_AVAILABLE_ERROR, payload: message });
    }
}

function* fetchAvailable() {
    yield takeLatest(Types.FETCH_AVAILABLE_START, fetchAvailableAsync);
}

export default function* sagas() {
    yield all([
        call(fetchStart),
        call(fetchAvailable),
    ]);
}
